import Vue from 'vue';
import { Component, Inject, Watch } from 'vue-property-decorator';
import { email, helpers, maxLength, minLength, required, sameAs } from 'vuelidate/lib/validators';
import RegisterService from '@/account/register/register.service';
import { COUNTRIES } from '@/constants';
import axios from 'axios';
import ConnectomeService from '@/entities/connectome/connectome.service';
import { Authority } from '@/shared/security/authority';
import { namespace } from 'vuex-class';
import { CmGroup } from '@/shared/model/cm-group.model';
import TermsOfUse from '@/account/register/terms-of-use/terms-of-use.vue';
import PrivacyPolicy from '@/account/register/privacy-policy/privacy-policy.vue';
import PhoneService from '@/account/phone.service';
import { getCurrentTimeZoneOffset, LOCAL_STORAGE_CONSTANTS } from '@/shared/constants/ds-constants';
import { convertDateToCustomFormat } from '@/util/date-util';
import { removeUnUsedSpace } from '@/util/string.util';
import { hideElementById } from '@/util/style-util';
import { getBrowserLang } from '@/util/guest-util';
import PublicService from '@/service/public.service';

const groupsManagerStore = namespace('groupsManagerStore');
const navbarStore = namespace('navbarStore');
const appStoreState = namespace('appStore');

const validations: any = {
  formModel: {
    phoneNumber: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(50),
    },
    email: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(254),
      email,
    },
    code: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(50),
    },
  },
  purposeSelected: {
    required,
    checked(val) {
      return val;
    },
  },
  aiName: {
    required,
    minLength: minLength(2),
    maxLength: maxLength(254),
  },
};

@Component({
  validations,
  components: {
    'terms-of-use': TermsOfUse,
    'privacy-policy': PrivacyPolicy,
  },
  computed: {
    getCurrentLanguage() {
      return this.$store.getters.currentLanguage;
    },
  },
})
export default class Register extends Vue {
  @Inject('registerService') private registerService: () => RegisterService;
  @Inject('connectomeService') private connectomeService: () => ConnectomeService;
  @Inject('phoneService') private phoneService: () => PhoneService;
  @Inject('publicService') private publicService: () => PublicService;

  @groupsManagerStore.Action
  public loadUserContext!: (payload: {
    connectomeId: string;
    language: string;
  }) => Promise<{ status: string; message: string; result: any }>;

  @navbarStore.Action
  public setCollectionLoadAc!: (payload: { newVal: boolean }) => void;

  @navbarStore.Action
  public setCollectionLoading!: (payload: { newVal: boolean }) => void;

  @navbarStore.Getter
  public isCollectionLoaded!: boolean;

  @navbarStore.Getter
  public isCollectionLoading!: boolean;

  // @navbarStore.Action
  // public setResetCollection!: (payload: { newVal: boolean }) => void;

  @appStoreState.Getter
  public getIsShowPopupRegister!: boolean;

  @appStoreState.Mutation
  public setIsShowPopupRegister!: (payload: boolean) => void;

  langkey = this.$store.getters.currentLanguage;

  public error = '';
  public success = false;
  public step = 1;
  private isNext = 1;
  public policies = [];
  public isSelectAll = false;
  public purposes;
  public verifyFormModel = {
    countryCode: '',
    phoneNumber: '',
    type: 1,
    code: '',
    email: '',
    emailCode: '',
    login: '',
    timeZone: '',
  };

  public registerFormModel = {
    countryCode: '',
    phoneNumber: '',
    email: '',
    code: '',
    emailCode: '',
    purposeSet: [],
    nameConnectome: 'Warren',
    login: '',
    lastName: '',
    deleted: 0,
    langKey: getBrowserLang(),
    authorities: [Authority.USER],
    invitationCode: '',
    isRegister: true,
    showOnboardDialog: 1,
    timeZone: getCurrentTimeZoneOffset(),
    isGuest: false,
    guestLogin: '',
    isEmailLogin: false,
    isUpdateGuestToUser: false,
    id: '',
  };
  public isInvalidMailOrPhone = false;
  public maxlength = false;
  public authenticationError = null;
  public connectomes = [];
  public minLeft = '3';
  public secLeft = '00';
  public countDown;
  public buttonPurposes = false;
  public file: any;
  private selectedLogin = 0;
  public isValid = false;
  isShowSpinner = false;
  public countries = COUNTRIES;
  public countrySelect = null;
  phoneTxt = '';
  mailTxt = '';
  isVerificationCodeSuccess = false;
  sendedVerificationCode = false;
  isAcceptOTP = false;
  isShowResentCodeForPhone = false;
  isTypeWithPhoneInput = false;
  isTypeWithMailInput = false;
  isTypeWithName = false;
  isReConFirmCode = false;
  isValidName = false;
  isShowResentCodeForEmail = false;
  isInCorrectPhone = false;
  waitingReceivingApi = false;
  waitingRegisterApi = false;

  created() {
    this.getAllPurposes();
    this.$root.$on('setLogin', this.setLogin);
    this.$root.$on('user-confirm-option', this.UserConfirm);
    if (sessionStorage.getItem('requested-url')) {
      sessionStorage.removeItem('requested-url');
    }
  }

  destroyed() {
    this.$root.$off('setLogin', this.setLogin);
    this.$root.$off('user-confirm-option', this.UserConfirm);
  }

  @Watch('getCurrentLanguage')
  changeLnagkey(newval) {
    this.registerFormModel.langKey = newval;
  }

  @Watch('phoneTxt')
  onPhoneTxtChange() {
    if (this.selectedLogin === 0) {
      this.isTypeWithPhoneInput = true;

      if (this.existedMailOrPhone) {
        this.existedMailOrPhone = false;
      }

      if (this.isInCorrectPhone) {
        this.isInCorrectPhone = false;
      }
    }
  }

  @Watch('mailTxt')
  onMailTxtChange() {
    if (this.selectedLogin === 1) {
      this.isTypeWithMailInput = true;

      if (this.existedMailOrPhone) {
        this.existedMailOrPhone = false;
      }
    }
  }

  @Watch('registerFormModel.lastName')
  onRegisterFormModelLastNameChange() {
    this.isTypeWithName = true;
  }

  @Watch('confirmCode')
  onConfirmCodeChange() {
    this.isReConFirmCode = true;
  }

  data() {
    return {
      purposes: this.purposes,
    };
  }

  confirmCode = '';
  isExpiredCode = false;
  isSendingCode = false;

  getVerificationCode(fromWhere?: string) {
    if (fromWhere && fromWhere === 'phoneInput') {
      this.isTypeWithPhoneInput = true;
    }

    if (fromWhere && fromWhere === 'emailInput') {
      this.isTypeWithMailInput = true;
    }

    if (fromWhere && fromWhere === 'emailInputResendCode') {
      this.isTypeWithMailInput = true;
      this.isSendingCode = false;
    }

    this.confirmCode = '';
    this.isExpiredCode = false;

    if (this.selectedLogin === 1) {
      this.mailTxt = this.mailTxt.replace(/\s+/g, '');

      if (!this.mailTxt || this.isSendingCode || this.isInvalidMailOrPhone || this.existedMailOrPhone) {
        return;
      }
      this.registerFormModel.email = this.mailTxt;
    } else {
      this.phoneTxt = this.phoneTxt.replace(/\s+/g, '');

      if (
        !this.phoneTxt ||
        (this.phoneTxt && this.phoneTxt.length < 6) ||
        !this.checkRegexPhone() ||
        this.existedMailOrPhone ||
        !this.countrySelect
      ) {
        return;
      }

      this.registerFormModel.countryCode = this.countrySelect;
      this.registerFormModel.phoneNumber = this.phoneTxt;
      this.registerFormModel.login = this.phoneTxt;
    }
    this.sendOTP();
    // this.hideVerifyButton = true;
  }

  existedMailOrPhone = false;
  SEND_CODE_TIMEOUT = 180;

  sendOTP() {
    this.registerService()
      .sendOTP(this.registerFormModel)
      .then(res => {
        this.existedMailOrPhone = false;
        this.registerFormModel.login = res.data.login;

        clearTimeout(this.countDown);
        this.countDownTimer(this.SEND_CODE_TIMEOUT);
        this.isSendingCode = true;
        this.isShowResentCodeForPhone = true;
        this.isInCorrectPhone = false;
        this.isShowResentCodeForEmail = true;
      })
      .catch(error => {
        this.isShowResentCodeForPhone = false;
        const err = error.response.data;
        switch (err.code) {
          case '010': {
            this.existedMailOrPhone = true;
            break;
          }
          case '011': {
            this.existedMailOrPhone = true;
            break;
          }
          case '003': {
            this.existedMailOrPhone = true;
            break;
          }
          case '004': {
            this.existedMailOrPhone = true;
            this.isInCorrectPhone = true;
            break;
          }
          default: {
            this.existedMailOrPhone = true;
            break;
          }
        }
      });
  }

  // callApiSendCodeToEmail() {
  //   this.existedMailOrPhone = false;
  //   if (this.minLeft === '0' && this.secLeft === '00') {
  //     // this.isSendingCode = false;
  //   } else {
  //     this.resetTime();
  //     clearTimeout(this.timeDown);
  //   }
  //
  //   this.registerFormModel.email = this.mailTxt;
  //   this.registerService()
  //     .sendEmailService(this.registerFormModel)
  //     .then(res => {
  //       this.isSendingCode = true;
  //       this.registerFormModel.login = this.mailTxt;
  //       this.registerFormModel.email = this.mailTxt;
  //
  //       clearTimeout(this.countDown);
  //       this.countDownTimer(this.SEND_CODE_TIMEOUT);
  //       this.isShowResentCodeForEmail = true;
  //     })
  //     .catch(error => {
  //       this.isShowResentCodeForEmail = false;
  //       const err = error.response.data;
  //       switch (err.code) {
  //         case '010': {
  //           this.existedMailOrPhone = true;
  //           break;
  //         }
  //         case '011': {
  //           this.existedMailOrPhone = true;
  //           break;
  //         }
  //         default: {
  //           this.$bvToast.toast(`${this.$t('newLearningCenter.unknownError')}`, {
  //             toaster: 'b-toaster-bottom-right',
  //             title: `${this.$t('newLearningCenter.error')}`,
  //             variant: 'danger',
  //             solid: true,
  //             autoHideDelay: 4000,
  //           });
  //           break;
  //         }
  //       }
  //     });
  // }

  timeDown;

  public countDownTimer(countDownTime: number) {
    if (countDownTime >= 0) {
      this.minLeft = '' + Math.floor(countDownTime / 60);
      // @ts-ignore
      this.secLeft = Math.floor(countDownTime % 60);
      // @ts-ignore
      this.secLeft = this.secLeft < 10 ? '0' + this.secLeft : this.secLeft;

      if (countDownTime > 0) {
        this.timeDown = this.countDown = setTimeout(() => {
          this.countDownTimer(countDownTime - 1);
        }, 1000);
      } else {
        this.isSendingCode = false;
        this.isExpiredCode = true;
      }
    }
  }

  confirm(isFromPopupRegister?: boolean) {
    if (!this.checkRegexCode() || !this.confirmCode || (this.confirmCode && this.confirmCode.length < 6)) {
      return;
    }

    if (!this.isVerificationCodeSuccess && this.sendedVerificationCode && this.isSendingCode && !this.isReConFirmCode) {
      return;
    }

    if (this.minLeft === '0' && this.secLeft === '00') {
      return;
    }

    // @ts-ignore
    if (this.minLeft == 0 && this.secLeft == 0 && this.sendedVerificationCode) {
      this.isExpiredCode = true;
      this.sendedVerificationCode = false;
      return;
    }

    this.handleSetDataForUserOrGuestAccount(isFromPopupRegister || undefined, false);
    this.verifyCode();
  }

  verifyCode() {
    this.registerFormModel.code = this.confirmCode;
    this.registerService()
      .verifyCode(this.registerFormModel)
      .then(res => {
        this.sendedVerificationCode = true;
        if (res?.data?.code == '000') {
          this.isVerificationCodeSuccess = true;
        }
        clearTimeout(this.countDown);
        this.$emit('update:loginFailedAttempt', 0);
      })
      .catch(error => {
        this.sendedVerificationCode = true;
        const err = error.response.data;
        this.$emit('update:loginFailedAttempt', err.loginFailedCount);
        this.isVerificationCodeSuccess = false;
      })
      .finally(() => {
        this.isReConFirmCode = false;
      });
  }

  public setLogin(login) {
    this.registerFormModel.login = login;
  }

  areAllRequiredIdsPresent() {
    if (!this.purposes || !this.policies) return false;
    const idSet = new Set(this.policies);

    return this.purposes.filter(item => item.required == 1).every(item => idSet.has(item.id));
  }

  public handleReceiving(isFromPopupRegister?: boolean) {
    if (this.waitingReceivingApi) {
      return;
    }
    const href = window.location.href;
    const page = href.split('/');
    this.registerFormModel.lastName = removeUnUsedSpace(this.registerFormModel.lastName);

    this.handleSetDataForUserOrGuestAccount(isFromPopupRegister || undefined, true);

    if (page[page.length - 1].includes('register') || (isFromPopupRegister !== undefined && isFromPopupRegister === true)) {
      this.waitingReceivingApi = true;
      this.registerService()
        .createUnActiveAccount(this.registerFormModel)
        .then(res => {
          this.registerFormModel.id = res.data.id;
          this.nextStep();
        })
        .catch(error => {
          const err = error.response.data;
          this.success = null;
          this.$bvToast.toast(err.message, {
            toaster: 'b-toaster-bottom-right',
            title: err.errorKey,
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          });
        })
        .finally(() => {
          this.waitingReceivingApi = false;
        });
    }
  }

  public nextStep(): void {
    this.step++;
    if (this.step >= this.isNext) {
      this.isNext++;
    }
  }

  public toggleAll(): void {
    if (this.policies.length == this.purposes.length) {
      this.policies = [];
    } else {
      this.policies = this.purposes.map(item => item.id);
    }
  }

  public toggleSelect(): void {
    this.isSelectAll = this.policies.length == this.purposes.length;
  }

  getAllPurposes() {
    axios.get('/api/purpose/getAll').then(res => {
      this.purposes = res.data;
    });
  }

  callApiAuthen(payload, isFromPopupRegister?: boolean) {
    axios
      .post('api/authenticate', payload)
      .then(result => {
        const bearerToken = result.headers.authorization;
        if (bearerToken && bearerToken.slice(0, 7) === 'Bearer ') {
          const jwt = bearerToken.slice(7, bearerToken.length);
          // sessionStorage.setItem('ds-authenticationToken', jwt);
          localStorage.setItem('ds-authenticationToken', jwt);
        }
        this.authenticationError = false;
        this.callApiConnectome(isFromPopupRegister !== undefined && isFromPopupRegister === true ? true : undefined);
      })
      .catch(error => {
        this.authenticationError = true;
        this.isShowSpinner = false;
      });
  }

  callApiConnectome(isFromPopupRegister?: boolean) {
    // this.connectomeService()
    // .getConnectomeByLogin(this.registerFormModel.login)
    // .then(res => {
    // console.log('res.data: ', res.data);
    // this.connectomes = res.data;
    // this.connectomeSelected = this.connectomes[0];

    // update local user
    // if (isFromPopupRegister !== undefined && isFromPopupRegister === true) {
    //   const localStorageUser = JSON.parse(localStorage.getItem('localStorageUser')) || null;

    // @ts-ignore
    // const resUser = this.connectomeSelected?.user ? this.connectomeSelected?.user : null;

    // if (localStorageUser) {
    // const tempUser = mergeObjectsUser(localStorageUser) || null;
    //
    // if (tempUser !== undefined && tempUser !== null) {
    //   localStorage.setItem('localStorageUser', JSON.stringify(tempUser));
    // }

    // console.log('tempUser: ', tempUser);
    // }
    // }

    // localStorage.setItem('login-type', 'email');
    // this.setResetCollection({ newVal: true });
    // this.$root.$emit('get-user-context');
    setTimeout(() => {
      this.isShowSpinner = false;

      if (isFromPopupRegister !== undefined && isFromPopupRegister === true) {
        window.location.reload();
      } else {
        if (this.$route.name !== 'Home') {
          this.$router.push('/home');
        }
      }
      // window.location.reload();
    }, 1000);
    // })
    // .catch(error => {
    // this.isShowSpinner = false;
    // });
  }

  // solve purposes checkbox
  handleCheckbox(isFromPopupRegister?: boolean) {
    if (this.waitingRegisterApi) {
      return;
    }
    this.isShowSpinner = true;
    this.buttonPurposes = false;
    this.registerFormModel.purposeSet = this.policies;
    if (!this.buttonPurposes) {
      this.waitingRegisterApi = true;
      this.registerService()
        .activeAccount(this.registerFormModel)
        .then(async res => {
          const data = {
            username: this.registerFormModel.login,
            password: this.registerFormModel.code || this.registerFormModel.emailCode,
            rememberMe: true,
            countryCode: this.registerFormModel.countryCode,
          };
          this.callApiAuthen(data, isFromPopupRegister !== undefined && isFromPopupRegister === true ? true : undefined);
        })
        .catch(error => {
          this.waitingRegisterApi = false;
          this.isShowSpinner = false;
        });
    }
  }

  setLocaleToCache(locale) {
    if (!locale) {
      return;
    }
    localStorage.setItem(LOCAL_STORAGE_CONSTANTS.LOCALE, locale);
  }

  setLocaleByIp() {
    const locale = localStorage.getItem(LOCAL_STORAGE_CONSTANTS.LOCALE);
    if (locale) {
      this.countrySelect = locale;
    } else {
      this.publicService()
        .getIpFromClient()
        .then((ip: string) => {
          this.publicService()
            .getLocationByIp(ip)
            .then(res => {
              this.countrySelect = this.countries.find(item => item.value == res?.data?.countryCode)?.value;
              this.setLocaleToCache(this.countrySelect);
            });
        });
    }
  }

  mounted() {
    document.body.setAttribute('data-menu', 'login');
    this.setLocaleByIp();
    this.policies = [];
    this.$bvModal.show('modal-register-success');
    this.registerFormModel.invitationCode = this.$route?.query?.c as string;
  }

  handleTypeLogin(type) {
    this.selectedLogin = type;
    // this.resetForm();
  }

  UserConfirm(result) {
    if (!this.policies.includes(result)) {
      this.policies.push(result);
      this.toggleSelect();
    }
  }

  checkRegexPhone() {
    this.phoneTxt = this.phoneTxt.trim().replace(' ', '');
    const pattern = new RegExp('\\b\\d{6,15}\\b');
    return pattern.test(this.phoneTxt);
  }

  checkRegexEmail() {
    this.mailTxt = this.mailTxt.trim().replace(/\s+/g, '');
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    this.isInvalidMailOrPhone = !pattern.test(this.mailTxt);
  }

  resetTime() {
    // this.isSendingCode = false;
    this.minLeft = '3';
    this.secLeft = '00';
  }

  checkRegexCode() {
    // this.isShowRequiredOptWarning = true;
    const numberRegex = /^\d+$/;
    return numberRegex.test(this.confirmCode);
  }

  convertDateToCustomFormat() {
    return convertDateToCustomFormat(new Date(), 'yyyy.MM.dd');
  }

  checkValidName() {
    // this.isTypeWithName = true;

    if (!this.registerFormModel?.lastName || (this.registerFormModel?.lastName && this.registerFormModel?.lastName.length === 0)) {
      this.isValidName = true;
    }

    const tempName = this.registerFormModel?.lastName || '';

    const tempNameRefactor = tempName.trim().replace(' ', '').replace(/\s+/g, '');

    if (tempNameRefactor && tempNameRefactor.length > 0) {
      this.isValidName = true;
    } else {
      this.isValidName = false;
    }
  }

  handleClosePopupRegister() {
    this.setIsShowPopupRegister(false);

    hideElementById('buttonClosePopupRegister', true);
  }

  handleBackStep() {
    if (this.step > 0) {
      this.step = this.step - 1;
    }
  }

  handleSetDataForUserOrGuestAccount(isFromPopupRegister?: boolean, isUpdateGuestToUser?: boolean) {
    if (isFromPopupRegister !== undefined && isFromPopupRegister === true) {
      const tempGuestLogin = JSON.parse(localStorage.getItem('localStorageUser')) || null;

      if (tempGuestLogin !== undefined && tempGuestLogin !== null) {
        const tempLogin = tempGuestLogin.login || tempGuestLogin.email || null;

        if (tempLogin !== undefined && tempLogin !== null && tempLogin?.trim()?.length > 0) {
          this.registerFormModel.guestLogin = tempLogin;
          this.registerFormModel.isGuest = true;
          this.registerFormModel.authorities = [Authority.GUEST];
          this.registerFormModel.isUpdateGuestToUser = false;

          if (isUpdateGuestToUser !== undefined && isUpdateGuestToUser !== null && isUpdateGuestToUser === true) {
            this.registerFormModel.isGuest = false;
            this.registerFormModel.authorities = [Authority.USER];
            this.registerFormModel.isUpdateGuestToUser = true;
          }
        }
      }
    } else {
      this.registerFormModel.guestLogin = '';
      this.registerFormModel.isGuest = false;
      this.registerFormModel.authorities = [Authority.USER];
      this.registerFormModel.isUpdateGuestToUser = false;
    }
  }
}
